/**
 * @typedef {object} DisplayInformation
 * @property {string} logoUrl
 * @property {string} iconUrl
 * @property {string} name
 */

/**
 * @param {object} props
 * @param {DisplayInformation} props.displayInformation
 * @param {boolean} props.showIcon
 * @param {string} props.className
 * @returns {React.JSX.Element}
 */
export const InsuranceProviderLogo = ({ displayInformation, showIcon = false, className }) => {
  const url = showIcon ? (displayInformation?.iconUrl ?? displayInformation?.logoUrl) : displayInformation?.logoUrl;

  if (url) {
    return <img alt={displayInformation.name} className={className} src={url} />;
  }

  return null;
};
